import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/logo.png';
import FacebookIcon from '../../assets/images/facebook-icon.svg?react';
import InstagramIcon from '../../assets/images/insta-icon.svg?react';
import TwitterIcon from '../../assets/images/x-icon.svg?react';
import LinkedinIcon from '../../assets/images/linkedin-icon.svg?react';
import './Footer.css';

const Footer = ({ variant = 'default' }) => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { label: 'Home', link: '/' },
    { label: 'Gift Shop', link: '/gift-shop' },
    { label: 'Coins Store', link: '/coins-store' },
    { label: 'Subscription Plans', link: '/subscription-plans' },
    { label: 'About Us', link: '/about-us' },
    { label: 'Contact Us', link: '/contact-us' },
  ];

  return (
    <footer className={`footer-main-container ${variant}`}>
      <div className="appContainer">
        <Row>
          <Col lg={4} md={6} sm={12} className="mb-4 mb-lg-0">
            <div className="footer-section">
              <img src={logo} alt="" width={100} className="img-fluid" />
              <ul className="footer-links d-flex flex-row mt-3 align-items-center gap-3">
                <li className='social-link'><a href="" className="footer-link fs-4"><FacebookIcon /></a></li>
                <li className='social-link'><a href="" className="footer-link fs-4"><TwitterIcon /></a></li>
                <li className='social-link'><a href="" className="footer-link fs-4"><InstagramIcon /></a></li>
                <li className='social-link'><a href="" className="footer-link fs-4"><LinkedinIcon /></a></li>
              </ul>
            </div>
          </Col>
          <Col sm={6} lg={4} className="mb-4 mb-lg-0">
            <div className="footer-section" style={{maxWidth: '320px'}}>
              <h6 className="fw-bold">About Us</h6>
              <p className='mb-0'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan</p>
            </div>
          </Col>

          <Col sm={6} lg={4} className="mb-4 mb-lg-0">
            <div className="footer-section">
              <h6 className="fw-bold">Navigation</h6>
              <ul className="footer-links mt-3">
                {footerLinks.map((link, index) => (
                  <li key={index}>
                    <Link to={link.link} className="footer-link">
                      {link.icon && <link.icon className="link-icon" />}
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </Col>
        </Row>

        <Row className="footer-bottom">
          <Col xs={12}>
            <div className="footer-bottom-content">
              <div className="copyright text-center w-100">
                <p className="mb-0">
                  © let's plan a date {currentYear}. All rights reserved.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </footer>
  );
};

export default Footer; 